export default function() {}



//////////////////
// WEBPACK FOOTER
// /~/d3-shape/src/noop.js
// module id = ZNKe
// module chunks = 0